module.exports = __webpack_public_path__ + "static/scale-model-of-durham-north-carolina-d846ba27e6246b6c18dca07002d1b9d9.png";